import { render, staticRenderFns } from "./Obituary.vue?vue&type=template&id=0a63161c&scoped=true"
import script from "./Obituary.vue?vue&type=script&lang=js"
export * from "./Obituary.vue?vue&type=script&lang=js"
import style0 from "./Obituary.vue?vue&type=style&index=0&id=0a63161c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63161c",
  null
  
)

export default component.exports